import { Component, OnInit } from '@angular/core';
import { DashboardService } from '@service/dashboard.service';
import { ToasterLibraryService } from '@service/index';

@Component({
    selector: 'app-upcoming-tasks-widget',
    templateUrl: './upcoming-tasks-widget.component.html',
    styleUrls: ['./upcoming-tasks-widget.component.scss']
})
export class UpcomingTasksWidgetComponent implements OnInit {
    public isLoaded = false;
    public tasks: Array<any> = [];

    constructor(
        private dashboardService: DashboardService,
        private toasterLibrary: ToasterLibraryService
    ) { }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.isLoaded = false;
        this.dashboardService.getUpcomingTasks().subscribe(
            (res: any) => {
                if (res && res.data && Array.isArray(res.data)) {
                    this.tasks = res.data.slice(0, 5);
                } else if (Array.isArray(res)) {
                    this.tasks = res.slice(0, 5);
                }
                this.isLoaded = true;
            },
            (err: any) => {
                this.toasterLibrary.error(null, err?.error?.message || 'Failed to load upcoming tasks');
                this.isLoaded = true;
            }
        );
    }

    getPriorityClass(priority: string): string {
        switch (priority?.toLowerCase()) {
            case 'high': case 'urgent': return 'badge-danger';
            case 'medium': return 'badge-warning';
            case 'low': return 'badge-info';
            default: return 'badge-secondary';
        }
    }
}